import React, { useEffect } from "react";
import { Grid, TextField, MenuItem, Typography, FormControl, Select, Box } from "@material-ui/core";
import { BootstrapInput } from "containers/labs/style";
import { labStatus, isPublic, isAutoSuspend } from "constants/admin/masters/labs";
import { useForm } from "hooks/useForm";
import uuid from 'react-uuid';
import { useStyles } from "../style";
import { getSelectedIdFromArray } from "utils/common";
import MultiSelect from "components/MultiSelect";

const General = (props) => {
    const classes = useStyles();
    const { labDetails, bindGeneralInfo } = props;

    const initialFormData = { // used to initialize the data
        name: '',
        status: "In Development",
        is_public_viewable: [],
        max_age: null,
        auto_suspend: [],
        prespawn_count: null,
        lab_type : "Run Lab"
    };


    const {
        handleChange,
        handleChangeCustom,
        data,
        populateForm,
        errors,
    } = useForm({
        initialValues: initialFormData,
        validations: {
            name: {
                required: {
                    value: true,
                    message: 'Lab Name is required.',
                },
            },
        },
    });

    useEffect(() => {
        initialFormData.name = labDetails.name || '';
        initialFormData.status = labDetails.status || 2;
        initialFormData.lab_type = labDetails.lab_type || "Run Lab";
        initialFormData.is_public = labDetails.is_public ? [0] : [];
        initialFormData.auto_suspend = labDetails.auto_suspend ? [0] : [];
        initialFormData.max_age = labDetails.max_age || null;
        initialFormData.prespawn_count = labDetails.prespawn_count || null;
        populateForm(initialFormData);
        //eslint-disable-next-line
    }, [labDetails])

    return (
        <>
            <Grid item xs={7} className={classes.gridOutline}>
                <Typography color="textPrimary" className={classes.subheader}>General</Typography>
                <TextField fullWidth
                    name="name"
                    label="Name"
                    variant="outlined"
                    value={data.name}
                    classes={{ root: classes.textField }}
                    onChange={handleChange('name')}
                    onBlur={() => bindGeneralInfo('name', data.name)}
                    InputProps={{
                        classes: {
                            input: classes.inputField,
                            root: classes.base,
                            focused: classes.focused,
                            notchedOutline: classes.notchedOutline
                        },
                    }}
                    InputLabelProps={{
                        shrink: true,
                        style: { color: '#2a2c2e' },
                    }}
                    error={(errors.name) ? true : false}
                    helperText={(errors.name) ? errors.name : null}
                />

                <FormControl className={classes.margin}>
                    <Box display={'flex'} className={classes.publicViewable}>
                        <Typography color="textPrimary" className={classes.inputLabel} style={{ marginTop: 6, marginBottom: 8, textDecoration: 'underline', padding: "5px" }}>Status</Typography>
                        <Select
                            labelId="demo-customized-select-label"
                            value={getSelectedIdFromArray(labStatus, data.status)}
                            input={<BootstrapInput />}
                            onChange={(event) => { handleChangeCustom('status', event.target.value) }}
                            onBlur={() => bindGeneralInfo('status', data.status)}

                        >
                            {labStatus.map((option) => {
                                return (
                                    <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                );
                            })}
                        </Select>


                        <MultiSelect
                            name={'is_public'}
                            selected={data?.is_public?.length > 0 ? [0] : []}
                            onChange={handleChangeCustom}
                            title={'is_public'}
                            data={isPublic}
                            error={errors['is_public']}
                            isSearchHidden={true}
                            handleBlur={() => bindGeneralInfo('is_public', data.is_public)}
                            showCheckboxesHorizontally
                        />

                        <MultiSelect
                            name={'auto_suspend'}
                            selected={data?.auto_suspend?.length > 0 ? [0] : []}
                            onChange={handleChangeCustom}
                            title={'auto_suspend'}
                            data={isAutoSuspend}
                            error={errors['auto_suspend']}
                            isSearchHidden={true}
                            handleBlur={() => bindGeneralInfo('auto_suspend', data.auto_suspend)}
                            showCheckboxesHorizontally
                        />

                        <Typography color="textPrimary" className={classes.inputLabel} style={{ margin: 6, textDecoration: 'underline' }}>Hard stop</Typography>
                        <TextField
                            name="max_age"
                            variant="outlined"
                            value={data.max_age}
                            type="number"
                            classes={{ root: classes.textField }}
                            onChange={handleChange('max_age')}
                            onBlur={() => {
                                bindGeneralInfo('max_age', data.max_age === "" ? null : data.max_age)
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.inputField,
                                    root: classes.base,
                                    focused: classes.focused,
                                    notchedOutline: classes.notchedOutline
                                },
                            }}
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#2a2c2e' },
                            }}
                            error={(errors.max_age) ? true : false}
                            helperText={(errors.max_age) ? errors.max_age : null}
                        />
                        <Typography color="textPrimary" className={classes.inputLabel} style={{ margin: 6, textDecoration: 'underline' }}>Prespawn Count</Typography>
                        <TextField
                            name="prespawn_count"
                            variant="outlined"
                            value={data.prespawn_count}
                            type="number"
                            classes={{ root: classes.textField }}
                            onChange={handleChange('prespawn_count')}
                            onBlur={() => {
                                bindGeneralInfo('prespawn_count', data.prespawn_count === "" ? null : data.prespawn_count)
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.inputField,
                                    root: classes.base,
                                    focused: classes.focused,
                                    notchedOutline: classes.notchedOutline
                                },
                            }}
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#2a2c2e' },
                            }}
                            error={(errors.prespawn_count) ? true : false}
                            helperText={(errors.prespawn_count) ? errors.prespawn_count : null}
                        />


                        
                    </Box>
                    {/* <Typography color="textPrimary" className={classes.inputLabel} style={{ marginTop: 6, marginBottom: 8, textDecoration: 'underline', padding: "5px" }}>Status</Typography>
                        <Select
                            labelId="demo-customized-select-label"
                            value={getSelectedIdFromArray(labType, data.lab_type)}
                            input={<BootstrapInput />}
                            onChange={(event) => { handleChangeCustom('lab_type', event.target.value) }}
                            onBlur={() => bindGeneralInfo('lab_type', data.lab_type)}

                        >
                            {labType.map((option) => {
                                return (
                                    <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                );
                            })}
                        </Select> */}
                </FormControl>
            </Grid>
        </>
    );
};
export default (General);
